"use strict";
// packages/contracts/src/compras.ts — Fase 13, Plano 13 (COMP-01, D-18).
//
// Contrato do módulo Compras: cadastro próprio de fornecedores (sem sincronizar com a Omie nesta fase) e lookups.
// Estendido pelos planos 13-15/16/18/20/21, nunca renomeado.
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILTROS_PRAZO_PEDIDO_COMPRA = exports.SITUACOES_PEDIDO_COMPRA = exports.SITUACOES_FORNECEDOR = void 0;
exports.SITUACOES_FORNECEDOR = ['ATIVO', 'INATIVO', 'A_CONFIRMAR'];
exports.SITUACOES_PEDIDO_COMPRA = ['ABERTO', 'PARCIALMENTE_RECEBIDO', 'CONCLUIDO', 'CANCELADO'];
exports.FILTROS_PRAZO_PEDIDO_COMPRA = ['ATRASADOS', 'PROXIMOS_7', 'PERIODO'];
//# sourceMappingURL=compras.js.map